import { LikeOutlined, DislikeOutlined, LikeFilled, DislikeFilled } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import './ManualActionSelector.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const MANUAL_ACTIONS = {
  LIKE_IT: 'LIKE_IT',
  DONT_LIKE_IT: 'DONT_LIKE_IT',
};

const ManualActionSelector = ({ value, onChange, readOnly = false, size = 'default' }) => {
  const iconSize = size === 'large' ? '24px' : '18px';

  if (readOnly && !value) return null;

  return (
    <div className="manual-action-selector-container" data-testid="manual-action-selector">
      {readOnly ? (
        <div className="manual-action-readonly">
          {value === MANUAL_ACTIONS.LIKE_IT ? (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="" placement="top">
                  {t('COMMENT_MANUAL_ACTION_LIKE_IT')}
                </Tooltip>
              }
            >
              <LikeFilled
                className="manual-action-icon like"
                style={{ fontSize: iconSize, color: '#67e0aeff' }}
                data-testid="manual-action-like-filled"
              />
            </OverlayTrigger>
          ) : value === MANUAL_ACTIONS.DONT_LIKE_IT ? (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="" placement="top">
                  {t('COMMENT_MANUAL_ACTION_DONT_LIKE_IT')}
                </Tooltip>
              }
            >
              <DislikeFilled
                className="manual-action-icon dislike"
                style={{ fontSize: iconSize, color: '#ff7676ff' }}
                data-testid="manual-action-dislike-filled"
              />
            </OverlayTrigger>
          ) : null}
        </div>
      ) : (
        <div className="manual-action-buttons">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="" placement="top">
                {t('COMMENT_MANUAL_ACTION_LIKE_IT')}
              </Tooltip>
            }
          >
            <button
              type="button"
              onClick={() =>
                onChange(value === MANUAL_ACTIONS.LIKE_IT ? null : MANUAL_ACTIONS.LIKE_IT)
              }
              className={`manual-action-button ${value === MANUAL_ACTIONS.LIKE_IT ? 'active' : ''}`}
              data-testid="manual-action-button-like"
            >
              {value === MANUAL_ACTIONS.LIKE_IT ? (
                <LikeFilled className="manual-action-icon like" style={{ fontSize: iconSize }} />
              ) : (
                <LikeOutlined className="manual-action-icon" style={{ fontSize: iconSize }} />
              )}
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="" placement="top">
                {t('COMMENT_MANUAL_ACTION_DONT_LIKE_IT')}
              </Tooltip>
            }
          >
            <button
              type="button"
              onClick={() =>
                onChange(value === MANUAL_ACTIONS.DONT_LIKE_IT ? null : MANUAL_ACTIONS.DONT_LIKE_IT)
              }
              className={`manual-action-button ${
                value === MANUAL_ACTIONS.DONT_LIKE_IT ? 'active' : ''
              }`}
              data-testid="manual-action-button-dislike"
            >
              {value === MANUAL_ACTIONS.DONT_LIKE_IT ? (
                <DislikeFilled
                  className="manual-action-icon dislike"
                  style={{ fontSize: iconSize }}
                />
              ) : (
                <DislikeOutlined className="manual-action-icon" style={{ fontSize: iconSize }} />
              )}
            </button>
          </OverlayTrigger>
        </div>
      )}
    </div>
  );
};

export { MANUAL_ACTIONS };
export default ManualActionSelector;
